
import * as React from 'react';
import { Paper, MenuItem, SelectField, RaisedButton, GridList } from 'material-ui';
import { RadioButtonGroup, RadioButton } from 'material-ui/RadioButton';
import JerseyRestApiService from '../JerseyRestApiService';
import {CopyToClipboard} from 'react-copy-to-clipboard';

const  FILE_UPLOAD_SIZE_LIMIT = 104857600;
const  FILE_UPLOAD_SAMSUNG_SIZE_LIMIT = FILE_UPLOAD_SIZE_LIMIT * 10; // Samsung Assets upload maximum size limit 1GB

const folderTypes = [{
    key: 'content/amp',
    name: 'Amp',
}, {
    key: 'content/games',
    name: 'Games',
}, {
    key: 'content/shopthelook',
    name: 'Shopthelook',
}, {
    key: 'content/tweet',
    name: 'Tweet',
}, {
    key: 'content/polls',
    name: 'Polls',
}, {
     key: 'content/assets',
     name: 'Assets',
 }];

const partnerTypes = [{
    key: 'samsung',
    name: 'Samsung',
}, {
    key: 'xiaomi',
    name: 'Xiaomi',
}, {
    key: 'gionee',
    name: 'Gionee',
}, {
     key: 'other',
     name: 'Other',
 }];
const styles = {
    container: {
        width: '400px',
        margin: 'auto',
        marginTop: '50px',
        padding: '20px',
    },
    alertStyle: {
        marginTop: '20px',
    },
    saveButtonStyle: {
        marginTop: '15px',
    },
    dialogContentStyle: {
        width: '400px',
    },
    copy:{
        height: 'fit-content',
        backgroundColor: '#e2e2e2',
        color: 'black',
        width: 'fit-content',
    },
};

interface Props {
    history?: any;
}

interface State {
    selectedFile: any;
    selectedFileSize: number;
    folderPath: string;
    subFolderPath: string;
    uploadStatus: string;
    responseText: string;
    statusCode: number;
    failureText: string;
    fileType: string;
}

class UploadFile extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            selectedFile: null,
            selectedFileSize: 0,
            folderPath: '-1',
            subFolderPath: '-1',
            uploadStatus: '',
            statusCode: 0,
            responseText: '',
            failureText: '',
            fileType: 'file',
        };
    }

    fileSelectHandler = event => {
        this.setState({
            ...this.state,
            selectedFile: event.target.files,
        });
    }
    folderSelectHandler = (event) => {
        this.setState({
            ...this.state,
            selectedFile: event.target.files,
        });
    }

    fileUploadHandler = () => {

        const { selectedFile, folderPath, subFolderPath, fileType } = this.state;
        const formData = new FormData();

        let fileSize = 0;

        for (let fileIndex = 0; fileIndex < selectedFile.length; fileIndex++) {
            let fileName = selectedFile[fileIndex].webkitRelativePath ? selectedFile[fileIndex].webkitRelativePath : selectedFile[fileIndex].name;
            formData.append('file', selectedFile[fileIndex], fileName);

            fileSize += selectedFile[fileIndex].size;
        }

        let samsungFileUploadFlag = false;
        if (folderPath === 'content/assets' && subFolderPath === 'samsung') {
            samsungFileUploadFlag = true;
            if (fileSize > FILE_UPLOAD_SAMSUNG_SIZE_LIMIT) {
                alert(` ${fileType} size is more than 1GB`);
                return;
            }
        }


        if (fileSize > FILE_UPLOAD_SIZE_LIMIT && !samsungFileUploadFlag) {
            alert(` ${fileType} size is more than 100MB`);
            return;
        }


        const payload = {
            folderPath,
            subFolderPath,
            formData,
        };

        const uploadFileToBlobPromise = JerseyRestApiService.uploadFileToBlob(payload);
        this.setState({
            ...this.state,
            uploadStatus: 'uploading',
        });

        uploadFileToBlobPromise.then((response: any) => {
            const s3Response = response;
            const encoded = encodeURI(s3Response.message);

            this.setState({
                ...this.state,
                responseText: encoded,
                statusCode: s3Response.statusCode,
                uploadStatus: 'success',

            });
        }).catch(err => {
            this.setState({
                ...this.state,
                uploadStatus: 'error',
                failureText: err,
            });
        });
    }

    onFolderPathChange = (value) => {
        this.setState({
            ...this.state,
            folderPath: value,
        });
    }

    onSubFolderPathChange = (value) => {
        this.setState({
            ...this.state,
            subFolderPath: value,
        });
    }

    _addDirectory(node) {
        if (node) {
            node.directory = true;
            node.webkitdirectory = true;
        }
    }

    handleFileTypeChange = (event, value) => {
        this.setState({
            ...this.state,
            fileType: value,
        });
    }


    render() {

        const { folderPath, subFolderPath, responseText, statusCode, uploadStatus, selectedFile, fileType, failureText } = this.state;
        let fileUploadText = <span>File Uploaded Successfully</span>;
        if (statusCode == 200 && subFolderPath == 'samsung'){
            fileUploadText = (
              <span>
                File Uploaded Successfully -{' '}
                <span style={{ color: '#169916' }}>APK is Approved</span>
              </span>
            );
        }
        let response = <a href={responseText} target='_blank'>{responseText}</a>;
        if(statusCode == 202) {
            if(responseText.includes('Rejected')) {
                response = <h4 style={{ color: '#f25959' }}>"apk rejected"</h4>
            }else {
                response = <h4>"apk review in-progress"</h4>
            }
        }
        return (
            <div>
                <Paper style={styles.container} zDepth={2}>
                    <h4>File Upload</h4>
                    <SelectField
                        fullWidth={true}
                        floatingLabelText='Type'
                        value={folderPath}
                        onChange={(event, index, value) => this.onFolderPathChange(value)}
                    >
                        <MenuItem value={'-1'} primaryText={'Select Type'} key={'empty'}></MenuItem>
                        {
                            folderTypes.map(item => {
                                return (
                                    <MenuItem value={item.key} primaryText={item.name} key={item.name} />
                                );
                            })
                        }
                    </SelectField>

                    <SelectField
                        fullWidth={true}
                        floatingLabelText='Select Partner'
                        value={subFolderPath}
                        onChange={(event, index, value) => this.onSubFolderPathChange(value)}
                    >
                        <MenuItem value={'-1'} primaryText={'Select Partner'} key={'empty'}></MenuItem>
                        {
                            partnerTypes.map(item => {
                                return (
                                    <MenuItem value={item.key} primaryText={item.name} key={item.name} />
                                );
                            })
                        }
                    </SelectField>

                    <RadioButtonGroup name='actionType' defaultSelected={fileType} onChange={this.handleFileTypeChange}>
                        <RadioButton
                            value='file'
                            label='File'

                        />
                        <RadioButton
                            value='folder'
                            label='Folder'
                        />

                    </RadioButtonGroup>

                    {fileType === 'folder' && <input ref={node => this._addDirectory(node)} type='file' onChange={this.folderSelectHandler} />}
                    {fileType === 'file' && <input type='file' onChange={this.fileSelectHandler} />}


                    <GridList cols={1} padding={10} cellHeight='auto'>
                        <RaisedButton label={uploadStatus === 'uploading' ? 'Uploading' : 'Upload'} fullWidth={true} primary={true} style={styles.saveButtonStyle} onTouchTap={this.fileUploadHandler} disabled={selectedFile === null || folderPath === '-1' || uploadStatus === 'uploading'} />
                    </GridList>

                </Paper>

                {uploadStatus === 'success' && <div className='center'>
                    <pre><code>
                        {!responseText.includes('Rejected') && fileUploadText}
                        <br />
                        {response}
                        <br />
                        {statusCode != 202 && <CopyToClipboard text={responseText}>
                            <button style={styles.copy}>Copy link to clipboard</button>
                        </CopyToClipboard>}
                    </code></pre>
                </div>}

                {uploadStatus === 'error' && <div className='center'>
                    <pre><code>
                        <a target='_blank'>{failureText?failureText:'Something went wrong. Try again'}</a>
                    </code></pre>

                </div>}

            </div>



        );
    }
}

export default UploadFile;



// WEBPACK FOOTER //
// ./src/components/UploadFile.tsx